import React from 'react';
import { Box, IconButton, Popover, Alert } from '@mui/material';
import { useDispatch } from 'react-redux';
import { resetErrorFlag } from '../../../../store/search/actions';
import CancelIcon from '../../../../assets/icons/cancel-icon';
import makeStyles from './styles';
import { useClickOutside } from '../../../../globals/hooks/use-click-outside';

const noResultsErrorMessage = 'No results were found matching your search.';
const deviceInfoErrorMessage =
  'Error retrieving information and/or transaction details. Please see your System Administrator.';
const noDevicesErrorMessage = "No devices found for this asset.";
const forbiddenDevicesErrorMessage = "User is not authorized to perform this request";
const internalServerErrorMessage = "Internal server error. Please try again later.";// 500
const gatewayTimeoutErrorMessage = "Gateway timeout. Please try again later.";// 504
const networkFailureErrorMessage = "Network failure. Please check your connection and try again.";

const ErrorMessage = (properties: { open: boolean; element: any; deviceInfoError: boolean; deviceForbiddenError: boolean;deviceNotFoundError?: boolean;telematicsIdError?:boolean; internalServerError?:boolean; gatewayTimeoutError?:boolean; networkFailureError?:boolean; devicesList: boolean; errorMessage?: string;}) => {
  const { open, element, deviceInfoError, deviceForbiddenError,deviceNotFoundError, devicesList,internalServerError,gatewayTimeoutError,networkFailureError, errorMessage, } = properties;
  let errorFinalMessage = ''

  if (internalServerError) {
    errorFinalMessage = internalServerErrorMessage;
  } else if (gatewayTimeoutError) {
    errorFinalMessage = gatewayTimeoutErrorMessage;
  } else if (deviceNotFoundError) {
    errorFinalMessage = noDevicesErrorMessage;
  } else if (deviceInfoError) {
    errorFinalMessage = deviceInfoErrorMessage;
  } else if (devicesList) {
    errorFinalMessage = noResultsErrorMessage;
  } else if (deviceForbiddenError) {
    errorFinalMessage = forbiddenDevicesErrorMessage;
  } else if (networkFailureError) {
    errorFinalMessage = networkFailureErrorMessage;
  } else if (errorMessage) {
    errorFinalMessage = errorMessage;
  }
  const dispatch = useDispatch();
  const classes = makeStyles();

  useClickOutside([], () => {
    dispatch(resetErrorFlag());
  });

  return (
    <Popover
      id="errorPopover"
      open={open}
      anchorEl={element}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      style={errorMessage ? { width: '85%',transform: 'translate(5%, 0.5%)' }: {}}

    >
      <Alert
        style={errorMessage ? {} : { width: `${element && element.offsetWidth}px` }}
        className={classes.alert}
        severity="error"
      >
        <Box display="flex" alignItems="center" justifyContent="space-between">
          {errorMessage || errorFinalMessage}
          <IconButton size="large">
            <CancelIcon fill="red" />
          </IconButton>
        </Box>
      </Alert>
    </Popover>
  );
};

export default ErrorMessage;
